import React from 'react';
import {Redirect, Route, Switch} from "react-router";
import {css} from "aphrodite";
import SwitchA from "../pages/SwitchA";
import Config from "../../config/Config";
import SwitchB from "../pages/SwitchB";
import SwitchC from "../pages/SwitchC";
import SwitchD from "../pages/SwitchD";
import AsbMobile from "../pages/AsbMobile";
import GetAsb from "../pages/GetAsb";
import EmbedOpt1 from "../pages/EmbedOpt1";

const PageContent = ({extraStyle}) => {
    return (
        <div className={css(extraStyle)}>
            <Switch>
                <Route path={Config.paths.HOW_TO_SWITCH_A} component={SwitchA} exact/>
                <Route path={Config.paths.HOW_TO_SWITCH_B} component={SwitchB} exact/>
                <Route path={Config.paths.HOW_TO_SWITCH_C} component={SwitchC} exact/>
                <Route path={Config.paths.HOW_TO_SWITCH_D} component={SwitchD} exact/>
                <Route path={Config.paths.ASB_MOBILE} component={AsbMobile} exact/>
                <Route path={Config.paths.GET_ASB} component={GetAsb} exact/>
                <Route path={Config.paths.EMBED_OPT_1} component={EmbedOpt1} exact/>
                <Route path={Config.paths.EMBED_OPT_1_B} component={GetAsb} exact/>
                <Route path={Config.paths.EMBED_OPT_2} component={GetAsb} exact/>
                <Route path={Config.paths.EMBED_OPT_3} component={GetAsb} exact/>
                <Redirect from='*' to="/ASB/lp/HowtoSwitch/1"/>
            </Switch>
        </div>
    );
};

export default PageContent;
